import { render, staticRenderFns } from "./Detect.vue?vue&type=template&id=adc02cca&"
import script from "./Detect.vue?vue&type=script&lang=js&"
export * from "./Detect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adc02cca')) {
      api.createRecord('adc02cca', component.options)
    } else {
      api.reload('adc02cca', component.options)
    }
    module.hot.accept("./Detect.vue?vue&type=template&id=adc02cca&", function () {
      api.rerender('adc02cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/videoTrial/components/Detect.vue"
export default component.exports